module.exports = __webpack_public_path__ + "img/no-image.b40b4451.png";